import styles from '../globals/pages.module.scss'
import pageStyles from './styles.module.scss'

import { useEffect, useState } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'

import { Wrapper } from '../components/reusable'
import CfaBanner from '../components/cfaBanner'
import SingleSignatureContainer from '../components/singleSigContainer'
import { apiErrors } from '../helpers/apiErrors'
import PocView from '../components/pocView'
import { useUpdateClaimData } from '../claimProvider'
import DualSignatureContainer from '../components/dualSigContainer'
import PocSidebar from '../components/pocSidebar'

export default function CfaTransfer() {
    const [cfaData, setCfaData] = useState([])
    const [retrievedCfa, setRetrievedCfa] = useState(false)
    const [currentClaim, setCurrentClaim]: any = useState({})
    const { token } = useParams()
    const updateClaim = useUpdateClaimData()
    useEffect(() => {
        if (!retrievedCfa) {
            Loading.standard('Loading...')
            axios
                .post(`${process.env.REACT_APP_API_TOKEN_URL}/cfa-transfer`, { token })
                .then((response) => {
                    const responseData = response.data
                    if (responseData == 'CFA Complete') {
                        Report.success('Document Signed', 'Your Document has already been signed.', 'Okay', () => {
                            window.location.href = 'https://sentinellegal.co.uk'
                        })
                    }

                    const signatureData = responseData.signatureDataResult

                    if (!signatureData) throw new Error(responseData.error)
                    localStorage.setItem('name', `${signatureData[0].first_name} ${signatureData[0].last_name}`)
                    const startingClaim = signatureData.find((e: any) => e.status == 'CFA Link sent')
                    if (typeof startingClaim == 'undefined') {
                        Report.success('Document Signed', 'Your Document has already been signed.', 'Okay', () => {
                            window.location.href = 'https://sentinellegal.co.uk'
                        })
                    }

                    setCfaData(signatureData)
                    setCurrentClaim(startingClaim)
                    setRetrievedCfa(true)
                    updateClaim(signatureData[0])

                    Loading.remove()
                })
                .catch((e) => {
                    console.error('error:', e)
                    const serverError = e.response.data
                    Loading.remove()
                    apiErrors(serverError)
                })
        }
    }, [])

    const completePoc = (obj: any) => {
        Report.success(
            'CFA Complete',
            'Thank you for signing your documents. We will update you on your cases in due course.',
            'Okay',
            () => {
                window.location.href = 'https://sentinellegal.co.uk'
            }
        )

        return
    }

    const selectSidebarItem = (obj: any) => {
        setCurrentClaim(obj)
    }

    return (
        <div className={`${styles.pageContent} ${styles.pocContent}`}>
            <CfaBanner />
            <Wrapper>
                <PocView>
                    {cfaData.length > 1 && (
                        <PocSidebar
                            currentPoc={currentClaim}
                            allPocData={cfaData}
                            selectSidebarItem={selectSidebarItem}
                        />
                    )}
                    {retrievedCfa ? (
                        <DualSignatureContainer
                            signedAction={completePoc}
                            leftPreviewUrl={currentClaim.cfa_doc_url}
                            rightPreviewUrl={currentClaim.foa_doc_url}
                            extraPayload={{
                                type: 'fos-cfa-signature',
                                client_id: currentClaim.client_id,
                            }}
                        />
                    ) : (
                        <></>
                    )}
                </PocView>
            </Wrapper>
        </div>
    )
}
